import { Route, Routes } from 'react-router-dom'
import DownloadFile from '../pages/DownloadFile'
import Home from '../pages/Home'
import { DOWLOAD_PAGE_URL, HOME_PAGE_URL } from './clientUrls'

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path={HOME_PAGE_URL} element={<Home />} />
      <Route path={DOWLOAD_PAGE_URL} element={<DownloadFile />} />
      <Route path="*" element={<Home />} />
    </Routes>
  )
};